import { trackPerformanceBreakdown } from "./__internal__/trackPerformanceBreakdown";
export var trackMainJsExecuted = function() {
    trackPerformanceBreakdown({
        name: "mainJsExecuted"
    });
};
